import React from 'react';
import { ButtonLink } from '../components/ui/ButtonLink';
export function NotFound() {
  return <section className="flex min-h-[60vh] items-center py-24" data-id="element-727" data-mp="w3hntzqws5cw">
      <div className="mx-auto max-w-xl px-5 text-center" data-id="element-728" data-mp="w645wtbfe39d">
        <p className="text-sm font-medium text-ink-muted" data-id="element-729" data-mp="10539oalf7tz8">Page not found</p>
        <h1 className="mt-3 text-4xl font-semibold tracking-display" data-id="element-730" data-mp="1557q60mbwopg">This page isn’t in the workspace.</h1>
        <p className="mt-4 text-lg text-ink-soft" data-id="element-731" data-mp="1a2zhotj2a8t4">The link may be outdated. Start from the homepage or browse workspaces.</p>
        <div className="mt-8 flex justify-center gap-3" data-id="element-732" data-mp="1f1kjuyhvj2k7">
          <ButtonLink to="/" data-id="element-733" data-mp="1jtc1gjj1xxy7">Go home</ButtonLink>
          <ButtonLink to="/workspaces" variant="secondary" data-id="element-734" data-mp="1jundf6mnic0e">Workspaces</ButtonLink>
        </div>
      </div>
    </section>;
}